import { ChangeRequestsChangedEvent, IChangeRequestService, changeRequestService } from "../services/ChangeRequestService";
import { useEffect, useState } from "react";

/**
 * How many change requests of the space are `proposed` (`GET spaces/{id}/changesets?state=proposed&take=200`).
 * Undefined while unknown or when the server does not answer (e.g. a facade without the route yet) — the badge stays hidden.
 * Refreshes after an approve/reject/withdraw on the change-requests page.
 */
export function useProposedCount(spaceId: string | undefined, service?: IChangeRequestService): number | undefined {
    const [count, setCount] = useState<number | undefined>();
    const svc = service ?? changeRequestService();

    useEffect(() => {
        if (!spaceId) {
            setCount(undefined);
            return;
        }
        let alive = true;
        const load = () =>
            svc
                .list(spaceId, "proposed", 200)
                .then((items) => alive && setCount(items.length))
                .catch(() => alive && setCount(undefined));
        load();
        window.addEventListener(ChangeRequestsChangedEvent, load);
        return () => {
            alive = false;
            window.removeEventListener(ChangeRequestsChangedEvent, load);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [spaceId]);

    return count;
}
